import { Component, Input, TemplateRef } from "@angular/core";
import { NzSpinComponent } from "ng-zorro-antd/spin";
import { NzSafeAny, NzSizeLDSType } from "ng-zorro-antd/core/types";
import { WithConfig } from "ng-zorro-antd/core/config";
import { InputBoolean, InputNumber } from "ng-zorro-antd/core/util";

@Component({
  selector: "ui-spin",
  exportAs: "uiSpin",
  templateUrl: "spin.component.html",
  host: {
    "[class.ant-spin-nested-loading]": "!nzSimple",
  },
  styleUrls: ["spin.component.less"],
})
export class UiSpinComponent extends NzSpinComponent {
  @Input("spinIndicator") @WithConfig() nzIndicator: TemplateRef<NzSafeAny> | null = null;
  @Input("spinSize") nzSize: NzSizeLDSType = "default";
  @Input("spinTip") nzTip: string | null = null;
  @Input("spinDelay") @InputNumber() nzDelay = 0;
  @Input("spinSimple") @InputBoolean() nzSimple = false;
  @Input("isSpinning") @InputBoolean() nzSpinning = true;
}
